/** Prevents version.json + service worker paths from triggering reload loops. */

const RELOAD_GUARD_KEY = "app-reload-guard:v1";
const RELOAD_GUARD_MS = 20_000;

let reloadLock = false;

export function wasReloadGuardedRecently(): boolean {
  try {
    const raw = sessionStorage.getItem(RELOAD_GUARD_KEY);
    if (!raw) {
      return false;
    }
    const at = Number(raw);
    return Number.isFinite(at) && Date.now() - at < RELOAD_GUARD_MS;
  } catch {
    return false;
  }
}

export function tryAcquireReloadLock(): boolean {
  if (reloadLock || wasReloadGuardedRecently()) {
    return false;
  }

  reloadLock = true;
  try {
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  } catch {
    // sessionStorage may be unavailable
  }
  return true;
}

/** Call after a stable mount so intentional reloads (e.g. user action) still work later. */
export function clearReloadGuard(): void {
  reloadLock = false;
  try {
    sessionStorage.removeItem(RELOAD_GUARD_KEY);
  } catch {
    // ignore
  }
}
